import React from 'react';

/**
 * ProgressRing — SVG circular progress indicator.
 *
 * Props:
 *   percent    - 0–100
 *   size       - SVG size in px (default 60)
 *   stroke     - stroke width (default 5)
 *   color      - stroke color (default '#D67C2C')
 *   trackColor - background track color (default '#e5e7eb')
 *   label      - text shown in center (optional)
 *   sublabel   - smaller text below label (optional)
 *   className  - extra class on wrapper div
 */
const ProgressRing = ({
    percent = 0,
    size = 60,
    stroke = 5,
    color = '#D67C2C',
    trackColor = '#e5e7eb',
    label,
    sublabel,
    className = '',
}) => {
    const r = (size - stroke * 2) / 2;
    const circ = 2 * Math.PI * r;
    const offset = circ - (Math.min(100, Math.max(0, percent)) / 100) * circ;

    return (
        <div className={`relative inline-flex items-center justify-center ${className}`} style={{ width: size, height: size }}>
            <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
                {/* Track */}
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={r}
                    fill="none"
                    stroke={trackColor}
                    strokeWidth={stroke}
                />
                {/* Progress */}
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={r}
                    fill="none"
                    stroke={color}
                    strokeWidth={stroke}
                    strokeLinecap="round"
                    strokeDasharray={circ}
                    strokeDashoffset={offset}
                    style={{ transition: 'stroke-dashoffset 0.6s ease' }}
                />
            </svg>
            {(label !== undefined || sublabel !== undefined) && (
                <div className="absolute inset-0 flex flex-col items-center justify-center text-center leading-none px-1">
                    {label !== undefined && (
                        <span className="font-bold text-gray-800" style={{ fontSize: size * 0.2 }}>
                            {label}
                        </span>
                    )}
                    {sublabel !== undefined && (
                        <span className="text-gray-400 mt-0.5" style={{ fontSize: size * 0.14 }}>
                            {sublabel}
                        </span>
                    )}
                </div>
            )}
        </div>
    );
};

export default ProgressRing;
